import type { Translations } from './en';

export const fr: Translations = {
  app_name: 'CueTitan',
  login: {
    title: 'Connexion Personnel',
    pin_label: 'Entrez le PIN',
    submit: 'Connexion',
    locked: 'Trop de tentatives. Réessayez dans {{seconds}}s.',
    wrong_pin: 'PIN incorrect',
    must_change: 'Vous devez changer votre PIN avant de continuer.',
    change_pin: 'Changer le PIN',
    new_pin: 'Nouveau PIN (4-6 chiffres)',
    confirm_pin: 'Confirmer le PIN',
    pins_no_match: 'Les PINs ne correspondent pas',
    pin_too_short: 'Le PIN doit être de 4-6 chiffres',
    pin_changed: 'PIN changé avec succès',
  },
  game: {
    frame: 'Manche',
    of: 'de',
    score: 'Score',
    break: 'Break',
    reds: 'Rouges',
    frames: 'Manches',
    active_player: 'Actif',
    switch_player: 'Changer de joueur',
    concede_frame: 'Abandonner la manche',
    undo: 'Annuler',
    next_frame: 'Manche suivante',
    end_game: 'Fin du jeu',
    reset_frame: 'Réinitialiser la manche',
    foul: 'Faute',
    free_ball: 'Balle libre',
    miss: 'Manqué',
    confirm_concede: 'Abandonner cette manche ?',
    confirm_reset: 'Réinitialiser la manche courante ? Les scores seront perdus.',
    confirm_end: 'Terminer la partie ? Tout sera sauvegardé.',
    start_game: 'Démarrer la partie',
    player_1: 'Joueur 1',
    player_2: 'Joueur 2',
    frames_target: 'Objectif de manches',
    open_ended: 'Sans limite',
    press_to_start: 'Appuyez sur une touche pour commencer',
    resume_game: 'Reprendre la partie',
    menu: 'Menu',
    time: 'Temps',
    left: 'Restantes',
    vs: 'VS',
    breaking: 'Au break',
    half_century: 'Demi-siècle',
    century: 'Siècle',
    frame_complete: 'Manche terminée',
    next_frame_hint: 'Appuyez sur {{key}} pour la suivante',
    pot_red: 'Empochez une rouge',
    pot_color: 'Empochez une couleur',
    colors_next: 'Couleurs — {{ball}} suivante',
    colors_complete: 'Couleurs — complètes',
    no_active_game: 'Aucune partie en cours',
    up_next: 'Prochain',
    no_players_waiting: 'Aucun joueur en attente',
    games: 'Parties',
    best_break: 'Meilleur break',
    foul_hint: 'Sélectionnez la bille touchée (min 4 pts)',
    hint_red: 'Rouge',
    hint_color: 'Couleur',
    hint_undo: 'Annuler',
    hint_switch: 'Changer',
    hint_next: 'Suivant',
    hint_reset: 'Réinit.',
    hint_end: 'Fin',
    hint_queue: 'File',
  },
  waiting: {
    title: 'Liste d\'attente',
    add_player: 'Ajouter un joueur',
    name_placeholder: 'Nom complet...',
    add: 'Ajouter',
    remove: 'Retirer',
    start_match: 'Démarrer le match',
    qr_title: 'QR d\'auto-inscription',
    qr_hint: 'Les joueurs peuvent scanner pour rejoindre la liste',
    empty: 'Aucun joueur en attente',
    position: '#{{pos}}',
    clear_all: 'Tout effacer',
    move_up: 'Monter',
    move_down: 'Descendre',
  },
  stats: {
    title: 'Statistiques',
    total_games: 'Total des parties',
    total_revenue: 'Revenu total',
    top_players: 'Meilleurs joueurs',
    date_from: 'Du',
    date_to: 'Au',
    player_search: 'Nom du joueur',
    export_pdf: 'Exporter PDF',
    export_excel: 'Exporter Excel',
    staff_filter: 'Personnel',
    type_filter: 'Type',
    all: 'Tous',
    clear: 'Effacer',
    no_games: 'Aucune partie trouvée.',
    columns: {
      date: 'Date',
      player1: 'Joueur 1',
      player2: 'Joueur 2',
      winner: 'Vainqueur',
      frames: 'Manches',
      amount: 'Montant',
      staff: 'Personnel',
    },
  },
  tables: {
    floor: 'Terrain',
    in_use: 'Occupée',
    free: 'Libre',
    waiting: 'En attente',
    available: 'Disponible',
    reserved: 'Réservée',
    maintenance: 'Maintenance',
    live: 'En direct',
    tap_to_start: 'Appuyez sur une table pour démarrer ou reprendre une partie',
    snooker: 'Snooker',
    eight_ball: '8-Ball',
    add_table: 'Ajouter une table',
    session_history: 'Historique des sessions',
    no_history: 'Aucune partie terminée sur cette table.',
    type: 'Type',
  },
  settings: {
    title: 'Paramètres',
    club_name: 'Nom du club',
    logo: 'Logo du club',
    upload_logo: 'Télécharger le logo',
    price_per_frame: 'Prix par manche',
    currency: 'Devise',
    undo_limit: 'Limite d\'annulation',
    retention_days: 'Rétention des stats (jours)',
    keep_forever: 'Conserver indéfiniment',
    server_enabled: 'Serveur local',
    server_port: 'Port du serveur',
    local_ip: 'IP locale',
    qr_code: 'QR du serveur',
    reset_pin: 'Réinitialiser le PIN',
    purge_data: 'Purger les anciennes données',
    purge_confirm: 'Ceci supprimera toutes les données de jeu antérieures à la période de rétention. Continuer ?',
    language: 'Langue',
    save: 'Enregistrer',
    saved: 'Paramètres sauvegardés',
    logo_change: 'Changer le logo',
    logo_upload: 'Télécharger le logo',
    logo_remove: 'Retirer le logo',
    logo_hint: 'PNG, JPG, WebP ou SVG · max {{kb}}Ko',
    logo_too_large: 'Image trop grande (max {{kb}}Ko)',
    logo_not_image: 'Veuillez choisir une image',
    logo_read_error: 'Lecture du fichier impossible',
    section_club: 'Club',
    section_pricing: 'Tarifs',
    section_gameplay: 'Jeu',
    section_retention: 'Rétention des données',
    section_server: 'Serveur local',
    default_p1: 'Nom par défaut Joueur 1',
    default_p2: 'Nom par défaut Joueur 2',
    audio_enabled: 'Effets sonores',
    color_assist: 'Aide à la vision des couleurs',
    section_accessibility: 'Accessibilité et Audio',
    work_start_time: 'Heure de début de travail',
    work_end_time: 'Heure de fin de travail',
  },
  staff: {
    title: 'Gestion du personnel',
    add_staff: 'Ajouter du personnel',
    add_manager: 'Ajouter un manager',
    name: 'Nom',
    role: 'Rôle',
    pin: 'PIN',
    deactivate: 'Désactiver',
    reset_pin: 'Réinitialiser le PIN',
    no_staff: 'Aucun membre du personnel',
    active_staff: 'Personnel actif',
    change_my_pin: 'Changer mon PIN',
    new_pin: 'Nouveau PIN',
    confirm_pin: 'Confirmer le PIN',
    pin_updated: 'PIN mis à jour avec succès.',
    tables_btn: 'Tables',
    assigned_tables: 'Tables assignées',
    no_tables: 'Aucune table configurée.',
    no_restriction: 'toutes les tables visibles (sans restriction)',
    pin_reset_pending: 'Réinitialisation PIN en attente',
    temp_pin_for: 'PIN temporaire pour',
    temp_pin_hint: 'Il devra le modifier à la prochaine connexion.',
  },
  nav: {
    home: 'Accueil',
    game: 'Partie',
    waiting: 'Liste d\'attente',
    stats: 'Stats',
    settings: 'Paramètres',
    staff: 'Personnel',
    logout: 'Déconnexion',
  },
  common: {
    confirm: 'Confirmer',
    cancel: 'Annuler',
    save: 'Enregistrer',
    close: 'Fermer',
    yes: 'Oui',
    no: 'Non',
    ok: 'OK',
    loading: 'Chargement...',
    error: 'Une erreur est survenue',
  },
  join: {
    title: 'Rejoindre la liste d\'attente',
    subtitle: 'Entrez votre nom pour rejoindre la liste d\'attente',
    name_placeholder: 'Votre nom complet',
    submit: 'Rejoindre',
    success_title: 'Vous êtes inscrit !',
    success_message: 'Vous avez été ajouté à la liste d\'attente. Un membre du personnel vous appellera quand ce sera votre tour.',
    join_another: 'S\'inscrire à nouveau',
    error_empty: 'Veuillez entrer votre nom',
    error_failed: 'Échec de l\'inscription. Veuillez réessayer.',
  },
};
